import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import { HiChevronRight, HiChevronLeft } from "react-icons/hi";

import AppWrap from "wrapper/AppWrap";
import MotionWrap from "wrapper/MotionWrap";
import { urlFor, client } from "client";

import "./Testimonial.scss";
import { useTranslation } from "react-i18next";
const Testimonial = () => {
  const { t } = useTranslation();
  const [brands, setBrands] = useState([]);
  const [testimonial, setTestimonial] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const query = '*[_type == "testimonials"]';
    client.fetch(query).then((data) => {
      setTestimonial(data);
    });
    const brandQuery = "*[_type == 'brands']";
    client.fetch(brandQuery).then((data) => {
      setBrands(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text">{t("section.testimonial")}</h2>
      {testimonial?.length && (
        <>
          <div className="app__testimonial-item app__flex">
            <img
              src={urlFor(testimonial[currentIndex].imgUrl)}
              alt="testimonial"
            />
            <div className="app__testimonial-content">
              <p className="p-text">{testimonial[currentIndex].feedback}</p>
              <div>
                <h4 className="head-text">{testimonial[currentIndex].name}</h4>
                <h5 className="p-text">{testimonial[currentIndex].company}</h5>
              </div>
            </div>
          </div>
          <div className="app__testimonial-btns app__flex">
            <div
              className="app__flex"
              onClick={() =>
                handleClick(currentIndex === 0 ? 0 : currentIndex - 1)
              }
            >
              <HiChevronLeft />
            </div>
            <div
              className="app__flex"
              onClick={() =>
                handleClick(
                  currentIndex === testimonial.length - 1
                    ? testimonial.length - 1
                    : currentIndex + 1
                )
              }
            >
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      <div className="app__testimonial-brands app__flex">
        {brands.map((brand, index) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: "tween" }}
            key={index}
          >
            <img src={urlFor(brand.imgUrl)} alt="brand" />
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, "app__testimonial"),
  "testimonial",
  "app__primarybg"
);
